export default __webpack_public_path__ + "static/media/Montserrat-ExtraLight.ef3c777f.ttf";